import React, { Component } from 'react'

import '../App.css';
import './styles/Services.css';

import ServicesDesktop from './Desktop/Services';
import ServicesMobile from './Mobile/Services';

import firebase from '../firebase';

export default class Services extends Component {

	constructor(props) {
		super(props);

		this.state = {
			line1: "Loading...",
			line2: "Loading...",
			line3: "Loading...",
			line4: "Loading..."
		}
	}

	componentDidMount() {
		const servicesRef = firebase.database().ref('services');

		servicesRef.once('value').then((snapshot) => {
			let items = snapshot.val();

			this.setState({
				line1: items.line1,
				line2: items.line2,
				line3: items.line3,
				line4: items.line4
			});
		});
	}

  render() {

	if (this.props.isMobile) {
		return (
			<ServicesMobile 
				line1={this.state.line1}
				line2={this.state.line2}
				line3={this.state.line3}
				line4={this.state.line4}
				rightAction={this.props.rightAction} />
		);
	} else {
		return (
			<ServicesDesktop
				line1={this.state.line1}
				line2={this.state.line2}
				line3={this.state.line3}
				line4={this.state.line4}
				rightAction={this.props.rightAction} />
		);
	}
  }
}
